export const contentTableConfig = {
  title: '素材统计',
  tips: [
    {
      text: '如果选择，则只导出选择的素材数据。',
      style: 'color: #ff5722;font-size: 14px;margin-left: 10px;'
    },
    {
      text: '如果不选，则默认导出当前搜索条件下全部数据。',
      style: 'color: #01aaed;font-size: 14px;margin-left: 10px;'
    }
  ],
  propList: [
    { prop: 'materialId', label: '素材id', minWidth: '80' },
    {
      prop: 'materialTypeName',
      label: '素材类型',
      minWidth: '80',
      slotName: 'type'
    },
    {
      prop: 'longterm',
      label: '长效素材',
      minWidth: '80',
      slotName: 'longterm'
    },
    { prop: 'materialTitle', label: '素材标题/发送关键词', minWidth: '150' },
    { prop: 'send', label: '发送数', minWidth: '80', sortable: true },
    { prop: 'reply', label: '回复数', minWidth: '80', sortable: true },
    {
      label: '回复率',
      minWidth: '80',
      prop: 'replyPercent',
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.replyPercent.replace('%', '')) / 100 -
          parseFloat(b.replyPercent.replace('%', '')) / 100
        )
      },
      sortable: true
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'special'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: true
}
